import React, {useState} from 'react';
import {Button,TextField,Dialog, DialogContent , DialogTitle }from '@mui/material';
// import 'react-toastify/dist/ReactToastify.css';
import { shareNewsAPI} from "../../../apis/my_service";

// const Email = ({showEmailModal, emailModalToggle, scrapeidx, toastMsg }) => {
const EmailModal = ({showEmailModal, emailModalToggle, scrapeidx }) => {

    const [targetemail, setTargetemail] = useState('') //메일 수신인
    const [emailTitle, setEmailTitle] = useState('') // 메일 제목
    const [usermsg, setUsermsg] = useState('') // 메일 내용

    const shareNews = () => {
        const sendlist = scrapeidx.join('|')

        const params = {
            targetemail : targetemail,
            scrapeidx : sendlist,
            subject : emailTitle,
            usermsg : usermsg
        }

        shareNewsAPI(params)
            .then(res => {
                // toastMsg(res.data.msg)
            })

        emailModalToggle()
    }

    return (

            <Dialog open={showEmailModal} onClose={emailModalToggle}  fullWidth>
                <DialogTitle>받는 사람</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        placeholder='받으시는 분의 메일을 입력해주세요.'
                        margin="dense"
                        type="email"
                        fullWidth
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                        sx={{bgcolor: '#f7f7f9', padding: '12px 16px'}}
                        onChange={(e)=> {
                            setTargetemail(e.target.value)
                        }}
                    />
                </DialogContent>
                <DialogTitle>제목</DialogTitle>
                <DialogContent>
                    <TextField
                        id='outlined-multiline-static'
                        autoFocus
                        placeholder='메일 제목을 입력해주세요.'
                        margin="dense"
                        type="text"
                        fullWidth
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                        sx={{bgcolor: '#f7f7f9',  padding: '12px 16px'}}
                        onChange={(e)=> {
                            setEmailTitle(e.target.value)
                        }}
                    />
                </DialogContent>
                <DialogTitle>본문</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        placeholder='내용을 작성해주세요.'
                        margin="dense"
                        type="text"
                        fullWidth
                        multiline
                        rows={8}
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                        sx={{bgcolor: '#f7f7f9',  padding: '12px 16px'}}
                        onChange={(e)=> {
                            setUsermsg(e.target.value)
                        }}
                    />
                </DialogContent>
                <Button  sx={{bgcolor: 'black', color: '#fff', margin:'30px', fontSize:'18px', height:'56px'}} onClick={shareNews}>메일로 공유하기</Button>
            </Dialog>

    )
}

export default EmailModal;